export enum PlanogramCanvasLayer {
	Planogram = 'planogram',
	Blocks = 'blocks',
	PosMaterials = 'posMaterials',
	Sizes = 'sizes',
	Tooltips = 'tooltips',
	Tools = 'tools'
}

export const ALL_PLANOGRAM_CANVAS_LAYERS: ReadonlyArray<PlanogramCanvasLayer> = [
	PlanogramCanvasLayer.Planogram,
	PlanogramCanvasLayer.Blocks,
	PlanogramCanvasLayer.PosMaterials,
	PlanogramCanvasLayer.Sizes,
	PlanogramCanvasLayer.Tooltips,
	PlanogramCanvasLayer.Tools
];

/** Layers whose content affects planogram bounds and may require canvas resize. */
export const PLANOGRAM_CANVAS_RESIZE_LAYERS: ReadonlyArray<PlanogramCanvasLayer> = [
	PlanogramCanvasLayer.Planogram,
	PlanogramCanvasLayer.Blocks,
	PlanogramCanvasLayer.PosMaterials
];

export function resolvePlanogramCanvasLayers(layers?: ReadonlyArray<PlanogramCanvasLayer>): Array<PlanogramCanvasLayer> {
	return layers?.length ? [...layers] : [...ALL_PLANOGRAM_CANVAS_LAYERS];
}

export function shouldResizePlanogramCanvas(layers?: ReadonlyArray<PlanogramCanvasLayer>): boolean {
	return resolvePlanogramCanvasLayers(layers)
		.some((layer: PlanogramCanvasLayer) => PLANOGRAM_CANVAS_RESIZE_LAYERS.includes(layer));
}
